module.exports = "/_next/static/images/About-header-background-9268f2859fdd4d3b3dd8d206aeb69bd1.jpg";